<template>
  <div>
    <v-dialog v-model="dialog" max-width="290">
      <v-form id="filter-save-form" v-model="valid" ref="form" lazy-validation>
        <v-card>
          <v-container>
            <h2 class="text-xs-center">{{$t('student.filters.save_filter')}}</h2>
            <v-icon class="mr-1">mdi-blank</v-icon>
            <v-layout row justify-start>
              <v-text-field
                id="students-filter-title-field"
                v-model="studentsFilterTitle"
                class="mr-4 pt-1"
                clearable
                required
                :rules="requiredRule"
                :placeholder="$t('student.filters.filter_title')">
              </v-text-field>
            </v-layout>
            <v-layout row justify-start>
              <v-flex>
                <v-checkbox id="students-filter-default-cbox" v-model="defaultSearch" :label="$t('my_filter_save_default')"/>
              </v-flex>
            </v-layout>

          </v-container>
          <v-card-actions>
            <v-layout row justify-center class="pt-1 pb-1">
              <v-btn id="students-filter-cancel-btn" @click="closeModal">{{$t('student.filters.cancel')}}</v-btn>
              <v-btn id="students-filter-submit-btn" @click="saveModal" color="primary">{{$t('student.filters.save')}}</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
  import Helpers from '../../mixins/Helpers'
  import { mapActions, mapMutations, mapState } from 'vuex'
  import { SET_UNDO_TYPE, SET_INFORMATION_SNACKBAR_STATE, SET_INFORMATION_SNACKBAR_TEXT } from '../../store/mutation-types'
  import { SET_UNDO_STATE_ASYNC, SAVE_UPDATE_MY_FILTER } from '../../store/action-types'
  import { informationTexts } from '../../store/modules/information'

  export default {
    name: 'save-my-filter',
    mixins: [Helpers],
    data () {
      return {
        valid: false,
        filterTitle: '',
        defaultSearch: false,
        requiredRule: [v => !!v || this.$t('field_required'), v => (v && !this.nameExists(v)) || this.$t('filters.must_be_unique')]
      }
    },
    methods: {
      closeModal () {
        this.$emit('update:dialog', false)
        this.setSnackBarText(informationTexts.SAVE_FILTER_CANCEL)
        this.setSnackBar(true)
      },
      saveModal () {
        // only save filter if passed validation
        if (this.$refs.form.validate()) {
          this.savedFilterText(this.title)

          let obj = this.isNew
            ? {description: this.title, defaultSearch: this.defaultSearch}
            : {description: this.title, defaultSearch: this.defaultSearch, id: this.selectedFilterText.id}
          this.saveMyFilter(obj)
          this.$emit('update:dialog', false)
        }
      },
      ...mapActions({
        setUndoSnackBar: SET_UNDO_STATE_ASYNC,
        saveMyFilter: SAVE_UPDATE_MY_FILTER
      }),
      ...mapMutations({
        setUndoType: SET_UNDO_TYPE,
        setSnackBarText: SET_INFORMATION_SNACKBAR_TEXT,
        setSnackBar: SET_INFORMATION_SNACKBAR_STATE
      }),
      nameExists (value) {
        return this.filterTypes.myFilterIds.myFilters.map(el => el.description.toLowerCase()).includes(value.toLowerCase()) && this.isNew
      }
    },
    computed: {
      title () {
        return this.filterTitle.length > 0 ? this.filterTitle : this.selectedFilterText.title
      },
      isNew () {
        return this.title !== this.selectedFilterText.title
      },
      ...mapState({
        filterTypes: state => state.students.filterFields
      }),
      studentsFilterTitle: {
        get () {
          this.defaultSearch = this.selectedFilterText.defaultSearch ? this.selectedFilterText.defaultSearch : false
          // reset FilterTitle
          this.filterTitle = ''
          return this.selectedFilterText.title
        },
        set (value) {
          if ((value) && value.length > 0) {
            this.filterTitle = value
          }
        }
      }

    },
    props: {
      dialog: {
        default: false
      },
      selectedFilterText: {
        type: Object
      },
      savedFilterText: {
        type: Function
      }
    }
  }
</script>

<style scoped>
  .filter-list-rows {
    overflow: auto;
    height: 55vh;
    max-height: calc(100vh - 340px);
    -webkit-overflow-scrolling: touch;
  }
  /* Transitions */
  .filter-list-enter-active,
  .filter-list-leave-active {
    transition: all 0.4s;
    opaque: 1;
  }

  .filter-list-enter, .filter-list-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
    transform: translate(-16px, 0px)
  }
</style>



// WEBPACK FOOTER //
// src/components/filter/SaveMyFilter.vue